import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';
import tel from 'utils/phone';
import { Link } from '@ontruck/orc';
import { DetailNotFound } from './styled';
import { injectIntl } from 'react-intl';

const ContactRow = React.memo(({ className, stop, intl }) => {
  const t = intl.messages.modules.StopCard;
  return (
    <StyledRow className={className}>
      {!!stop.address.contact_name || !!stop.address.contact_phone ? (
        <Fragment>
          <div>{stop.address.contact_name}</div>
          <div>
            {<Link href={tel(stop.address.contact_phone)} text={stop.address.contact_phone} />}
          </div>
        </Fragment>
      ) : (
        <DetailNotFound>{t.no_contact}</DetailNotFound>
      )}
    </StyledRow>
  );
});

ContactRow.propTypes = {
  stop: PropTypes.object,
  className: PropTypes.string,
};

ContactRow.defaultProps = {
  stop: {},
  className: '',
};

export default injectIntl(ContactRow);
